import { useEffect } from 'react';

import { Icon, Stack, Text, useColorModeValue } from '@ecoinvent/ui';
import { BiCheckCircle } from 'react-icons/bi';

interface LoadingStateProps {
  onFinished: () => void;
}

const LoadingState = ({ onFinished }: LoadingStateProps) => {
  const textColor = useColorModeValue('gray.600', 'gray.300');

  useEffect(() => {
    const timer = setTimeout(onFinished, 2000);
    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <Stack align="center" justify="center" spacing={4} flex={1}>
      <Icon as={BiCheckCircle} boxSize={16} color="green.500" />
      <Stack spacing={1} align="center" textAlign="center">
        <Text fontWeight="medium" color={textColor}>
          Thank you!
        </Text>
        <Text color={textColor}>Your feedback will help us improve ecoQuery</Text>
      </Stack>
    </Stack>
  );
};

export default LoadingState;
